import { IMAGE_MANIFEST, ImageSources } from "@/images/generated/manifest";

/**
 * Productized offerings Devbloom builds and runs itself (as opposed to client
 * work in projects.ts). Each product links out to its own site; the copy lives
 * in the `products.items.<key>` i18n namespace.
 */
export type ProductStatus = "new" | "live";

export interface Product {
  slug: string;
  /** i18n key under `products.items`. */
  key: string;
  name: string;
  /** Canonical URL of the product's own site (no tracking params). */
  url: string;
  status: ProductStatus;
  featured: boolean;
  /** Short, language-neutral tags (brands, payment methods, platforms). */
  tags: readonly string[];
  /** Screenshot of the live product, run through scripts/optimize-images.js. */
  img: ImageSources;
}

export const PRODUCTS: readonly Product[] = [
  {
    slug: "tiendas",
    key: "tiendas",
    name: "Devbloom Tiendas",
    url: "https://tiendas.devbloom.dev",
    status: "new",
    featured: true,
    tags: ["Shopify", "PSE", "Nequi", "Bre-B"],
    img: IMAGE_MANIFEST.tiendas,
  },
] as const;

export const PRODUCT_UTM = {
  utm_source: "devbloom.dev",
  utm_medium: "products_section",
} as const;

/** Outbound link to the product site, tagged so its analytics can attribute the visit. */
export function productHref(product: Pick<Product, "url">): string {
  const url = new URL(product.url);
  for (const [k, v] of Object.entries(PRODUCT_UTM)) url.searchParams.set(k, v);
  return url.toString();
}

export function findProductBySlug(slug: string): Product | undefined {
  return PRODUCTS.find((p) => p.slug === slug);
}
